/**
 * 密码强度验证工具
 */

class PasswordValidator {
    /**
     * 检查密码强度
     * @param {string} password - 要检查的密码
     * @returns {Object} 包含强度评分和反馈的对象
     */
    static validate(password) {
        if (!password) {
            return {
                isValid: false,
                score: 0,
                feedback: ['请输入密码']
            };
        }

        const checks = {
            length: password.length >= 12,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            number: /\d/.test(password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            commonPattern: !this.isCommonPattern(password),
            repeatingChars: !/(.)\1{3,}/.test(password),
            sequentialChars: !/(?:abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i.test(password)
        };

        const feedback = [];
        if (!checks.length) feedback.push('密码至少12位');
        if (!checks.uppercase) feedback.push('需要大写字母');
        if (!checks.lowercase) feedback.push('需要小写字母');
        if (!checks.number) feedback.push('需要数字');
        if (!checks.special) feedback.push('需要特殊字符');
        if (!checks.commonPattern) feedback.push('避免常见模式');
        if (!checks.repeatingChars) feedback.push('避免重复字符');
        if (!checks.sequentialChars) feedback.push('避免连续字符序列');

        // 计算得分
        const passedChecks = Object.values(checks).filter(Boolean).length;
        const score = Math.min(4, Math.floor((passedChecks / Object.keys(checks).length) * 5));

        return {
            isValid: score >= 3,
            score,
            feedback
        };
    }

    /**
     * 检查是否为常见模式
     * @param {string} password - 要检查的密码
     * @returns {boolean}
     */
    static isCommonPattern(password) {
        const lowerPass = password.toLowerCase();
        const commonPatterns = [
            /^[0-9]+$/, // 纯数字
            /^[a-z]+$/, // 纯小写字母
            /^[A-Z]+$/, // 纯大写字母
            /^[!@#$%^&*()]+$/, // 纯特殊字符
            /^(?:qwerty|asdfgh|zxcvbn|password|admin|123456|654321)/, // 键盘模式
            /^(?:[a-zA-Z])\1{2,}/ // 重复字符开头
        ];
        return commonPatterns.some(pattern => pattern.test(lowerPass));
    }

    /**
     * 获取密码强度标签
     * @param {number} score - 强度得分
     * @returns {string}
     */
    static getStrengthLabel(score) {
        const labels = ['非常弱', '弱', '一般', '强', '非常强'];
        return labels[score] || labels[0];
    }

    /**
     * 获取密码强度颜色
     * @param {number} score - 强度得分
     * @returns {string}
     */
    static getStrengthColor(score) {
        const colors = ['#ff4d4f', '#ff7a45', '#faad14', '#a0d911', '#52c41a'];
        return colors[score] || colors[0];
    }
}

export default PasswordValidator;